import { render, staticRenderFns } from "./Wangeditor.vue?vue&type=template&id=6e01d032&"
import script from "./Wangeditor.vue?vue&type=script&lang=js&"
export * from "./Wangeditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports